// ═══════════════════════════════════════════════════════════════
// HOOK: useOrgUnits - CRUD para Unidades Organizativas
// ═══════════════════════════════════════════════════════════════

import { useState, useEffect, useCallback } from 'react';
import { useCompany } from '../../../contexts/CompanyContext';
import api from '../../../api/config';

export default function useOrgUnits() {
  const { currentCompany } = useCompany();
  const [orgUnits, setOrgUnits]   = useState([]);
  const [loading, setLoading]     = useState(true);
  const [error, setError]         = useState(null);

  const loadOrgUnits = useCallback(async () => {
    if (!currentCompany?.id) {
      setOrgUnits([]);
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      setError(null);
      console.log('📥 Cargando unidades organizativas...');
      const response = await api.get('/organizational-units');
      console.log('✅ Unidades cargadas:', response.data.length);
      setOrgUnits(response.data || []);
    } catch (err) {
      console.error('❌ Error cargando unidades organizativas:', err);
      setError(err.message);
      setOrgUnits([]);
    } finally {
      setLoading(false);
    }
  }, [currentCompany?.id]);

  useEffect(() => {
    loadOrgUnits();
  }, [loadOrgUnits]);

  const refresh = useCallback(async () => {
    console.log('🔄 Refrescando unidades organizativas...');
    await loadOrgUnits();
  }, [loadOrgUnits]);

  const addOrgUnit = async (data) => {
    try {
      console.log('➕ Creando unidad organizativa:', data);
      const response = await api.post('/organizational-units', data);
      console.log('✅ Unidad creada:', response.data);
      await refresh();
      return response.data;
    } catch (err) {
      console.error('❌ Error creando unidad:', err);
      throw err;
    }
  };

  const updateOrgUnit = async (id, data) => {
    try {
      console.log('✏️ Actualizando unidad:', id, data);
      const response = await api.put(`/organizational-units/${id}`, data);
      console.log('✅ Unidad actualizada:', response.data);
      await refresh();
      return response.data;
    } catch (err) {
      console.error('❌ Error actualizando unidad:', err);
      throw err;
    }
  };

  const deleteOrgUnit = async (id) => {
    try {
      console.log('🗑️ Eliminando unidad:', id);
      await api.delete(`/organizational-units/${id}`);
      console.log('✅ Unidad eliminada');
      await refresh();
    } catch (err) {
      console.error('❌ Error eliminando unidad:', err);
      if (err.response?.data?.error) {
        alert(`❌ ${err.response.data.error}`);
      } else {
        alert('❌ Error al eliminar la unidad organizativa');
      }
      throw err;
    }
  };

  return {
    orgUnits,
    loading,
    error,
    addOrgUnit,
    updateOrgUnit,
    deleteOrgUnit,
    refresh
  };
}
